import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const LinkPresentationPropsDefault: ComponentThemeProps["link"]["defaultProps"] = {
    color: "text.link",
    hoverMode: "darken",
};

export default LinkPresentationPropsDefault;
